
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-a-real-estate-agent-works-for-you",
      function () {
        return require("private-next-pages/how-a-real-estate-agent-works-for-you.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-a-real-estate-agent-works-for-you"])
      });
    }
  